module.exports = __webpack_public_path__ + "img/1696322223624-WhatsApp Image 2023-10-02 at 12.09.40.jpeg.2dbddaa5.webp";